<template>
    <div>
        <p class="text-small text-primary font-weight-medium mb-3">
            <i class="icon icon-Statussmallicon icon-lg me-2"><span class="icon path1"></span><span class="icon path2"></span></i>وضعیت تیکت‌ها{{ $route.path !== '/report' ? ' (یک سال گذشته)' : '' }}
        </p>
        <v-skeleton-loader v-if="skeleton" class="mx-auto" height="350" type="ossein"></v-skeleton-loader>
        <apexchart
            :options="chartOptions"
            :series="series"
            height="350"
            v-else
        ></apexchart>
    </div>
</template>
<script>
import fa from "apexcharts/dist/locales/fa.json";
import VueApexCharts from "vue3-apexcharts";
export default {
    components: {
        apexchart: VueApexCharts,
    },
    data() {
        return {
            skeleton: true,
            series: [],
            chartOptions: {
                chart: {
                    locales: [fa],
                    defaultLocale: "fa",
                    stacked: true,
                    type: "polarArea"
                },
                stroke: {
                    colors: ["#fff"],
                },
                fill: {
                    opacity: 0.8,
                },
                labels: [],
                legend: {
                    show: true,
                    fontFamily: "iransans",
                    fontWeight: 500,
                    position: "bottom",
                    markers: {
                        width: 10,
                        height: 10,
                        radius: 10,
                        offsetY: 1,
                        offsetX: 4,
                    },
                },
                tooltip: {
                    style: {
                        fontFamily: "iransans",
                    },
                },
                yaxis: {
                    labels: {
                        formatter: (val) => {
                            if (Math.round(val) == val) return val;
                            else if (Math.abs(val - Math.round(val)) < 0.15)
                                return Math.round(val);
                        },
                    },
                },
            },
            search: {},
        };
    },
    methods: {
        reportTicketStatusFilter(search) {
            this.skeleton = true;
            this.search = { ...search };
            this.reportTicketStatusGet();
        },
        reportTicketStatusGet() {
            this.$reportTicketStatusTicket(
                this.$route.path !== "/report"
                    ? { from_date: this.$moment().subtract(1, "years").unix() }
                    : this.search
            ).then((res) => {
                if (res && res.status == "OK") {
                    this.series = [];
                    this.chartOptions.labels = [];
                    this.chartOptions.labels.push(
                        ...res.data.map( (item) => this.$system.ticketStatuses.find(x => x.id == item.x).name )
                    );
                    this.series.push(
                        ...res.data.map((item) => item.total)
                    );
                    this.skeleton = false;
                }
            });
        },
    },
    mounted() {
        this.reportTicketStatusGet();
    },
};
</script>
